function App(props) {
  const fV = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  }).format(props.number || 0);
  return <span>{fV}</span>;
}

export default App;
